import React from 'react'
import './footer.css'
import { BsLinkedin, BsGithub } from 'react-icons/bs'
import { AiOutlineMail } from 'react-icons/ai'

export const Footer = () => {
    return (
        <div className='footer text-center'>
            <a
                title='linkedin'
                className='footer_icons'
                href='https://www.linkedin.com/in/vasanth-mn-91b368246/' target="_blank" rel="noreferrer"><BsLinkedin /></a>
            <a
                title='Githup'
                className='footer_icons'
                href='https://github.com/vasanthmn1' target="_blank" rel="noreferrer"><BsGithub />
            </a>
            <a
                title='Email'
                href='mailto:mnvasanthcode@gmail.com' className='footer_icons' target={'_blank'} rel="noreferrer">
                <AiOutlineMail />
            </a>


        </div>
    )
}
